// extracted by mini-css-extract-plugin
module.exports = {"comp":"Dialog_comp__7dXfE"};